import { Link } from "react-router";
import { PageMeta } from "../PageMeta";

export function ErrorPage() {
  return (
    <div className="min-h-screen bg-[var(--background)] text-[var(--foreground)] flex items-center justify-center px-6">
      <PageMeta
        title="Error – ADJUDON"
        description="An unexpected error occurred."
        noindex={true}
      />
      
      {/* Background */}
      <div 
        className="fixed inset-0"
        style={{
          background: "linear-gradient(to bottom, #0f0f0f 0%, #000000 40%, #0a0a0a 70%, #1a1a1a 100%)",
        }}
      />
      <div
        className="fixed inset-0 pointer-events-none opacity-[0.015]"
        style={{
          backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\")",
        }}
      />

      {/* Content - CENTERED wie Vercel */}
      <div className="relative z-10 text-center" style={{ maxWidth: "520px", width: "100%" }}>
        
        {/* Icon - Shield in dashed box (ADJUDON Logo) */}
        <div className="inline-flex items-center justify-center mb-10" style={{ width: "80px", height: "80px" }}>
          <div className="relative w-full h-full">
            <div 
              className="absolute inset-0 border"
              style={{ 
                borderColor: "rgba(255, 255, 255, 0.08)"
              }}
            />
            <div className="flex items-center justify-center w-full h-full">
              <svg className="w-9 h-9" viewBox="0 0 64 64" fill="var(--brand)" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <polygon points="8,52 8,6 18,6 24,14 24,52" />
                <polygon points="40,52 40,18 46,10 56,10 56,52" />
                <rect x="4" y="54" width="56" height="5" />
              </svg>
            </div>
          </div>
        </div>

        {/* Error Code */}
        <h1 className="mb-6" style={{ fontSize:"64px", lineHeight:"1", letterSpacing:"0.02em", fontWeight: 600, fontFamily:"var(--font-mono)" }}>
          ERROR
        </h1>
        
        {/* Message */}
        <p className="mb-12" style={{ 
          fontSize: "15px", 
          lineHeight: "1.6", 
          color: "var(--muted-foreground)"
        }}>
          Something went wrong while loading this page.
        </p>

        {/* Popular Pages */}
        <div className="mb-12">
          <div className="text-xs font-mono uppercase tracking-wider text-[var(--muted-foreground)] mb-4">
            Popular Pages
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="px-4 py-2 border border-[var(--border)] bg-transparent text-[var(--foreground)] text-sm font-mono hover:bg-[var(--surface-2)] transition-colors"
            >
              Home
            </Link>
            <Link
              to="/product"
              className="px-4 py-2 border border-[var(--border)] bg-transparent text-[var(--foreground)] text-sm font-mono hover:bg-[var(--surface-2)] transition-colors"
            >
              Product
            </Link>
            <Link
              to="/solutions"
              className="px-4 py-2 border border-[var(--border)] bg-transparent text-[var(--foreground)] text-sm font-mono hover:bg-[var(--surface-2)] transition-colors"
            >
              Solutions
            </Link>
            <Link
              to="/contact"
              className="px-4 py-2 border border-[var(--border)] bg-transparent text-[var(--foreground)] text-sm font-mono hover:bg-[var(--surface-2)] transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>

        {/* Primary CTA */}
        <Link
          to="/"
          className="inline-flex items-center justify-center px-8 h-11 bg-[var(--foreground)] text-[var(--background)] border border-[var(--foreground)] font-mono text-xs uppercase tracking-[0.1em] hover:bg-transparent hover:text-[var(--foreground)] transition-all"
        >
          Back to homepage
        </Link>

        {/* Technical Footer */}
        <div className="mt-16 pt-6 border-t border-[var(--border)]">
          <p className="text-[10px] font-mono text-[var(--muted-foreground)] uppercase tracking-wider">
            ERROR: UNKNOWN • {new Date().toISOString()}
          </p>
        </div>
      </div>
    </div>
  );
}